import { api } from '@/services/apiService'

export const chatService = {
  async getToken() {
    const res = await api.get<{ token: string }>(`/chat/get_token/`)

    return res.data.token
  },
}
